import React, { Component } from "react";

import Responsive from "react-responsive";

import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from "@material-ui/core/CircularProgress";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";

import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from "@material-ui/core/Toolbar";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";


import AppTheme from "../AppTheme";
import { Pie } from "react-chartjs-2";

import * as ClaimsService from "../services/claims";

import { sendClaim } from "../services/claims";

import { isSendButtonDisabled } from "./RequestForm.logic";

import styles from "./RequestFormStyles";

import BedsAvailabilityCardBar from "../BedsDashboard/BedsAvailabilityCardBar/BedsAvailabilityCardBar";


import moment from "moment";

import {
  getNow
} from "./../services/dashboard";

const FIELD_ERROR_MESSAGES = {
  firstName: {
    required: "Numele pacientului este obligatoriu!",
    validation: ""
  },
  lastName: {
    required: "Prenumele pacientului este obligatoriu!",
    validation: ""
  },

  diagnostic: {
    required: "Introducerea diagnosticului este obligatorie!",
    validation: ""
  },
  phoneNumber: {
    required: "Introducerea numarului de telefon este obligatorie!",
    validation: "Numarul de telefon este invalid!"
  },
  email: {
    required: "Introducerea adresei de email este obligatorie!",
    validation: "Emailul este invalid!"
  },
  hospital: {
    required: "",
    validation: ""
  }
};

const FIELD_VALIDATORS = {
  phoneNumber: inputValue => {
    // eslint-disable-next-line
    return inputValue.match(
      /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
    );
  },
  email: inputValue => {
    // eslint-disable-next-line
    return inputValue.match(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }
};

const Desktop = props => <Responsive {...props} minWidth={1441} />;
const Tablet = props => (
  <Responsive {...props} minWidth={769} maxWidth={1440} />
);
const Mobile = props => <Responsive {...props} maxWidth={768} />;

class RequestForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formInputData: {
        firstName: "",
        lastName: "",
        diagnostic: "",
        phoneNumber: "",
        email: "",
        hospital: ""
      },
      errors: {
        firstName: {
          hasError: false,
          isPristine: true,
          message: ""
        },
        lastName: {
          hasError: false,
          isPristine: true,
          message: ""
        },
        diagnostic: {
          hasError: false,
          isPristine: true,
          message: ""
        },
        phoneNumber: {
          hasError: false,
          isPristine: true,
          message: ""
        },
        email: {
          hasError: false,
          isPristine: true,
          message: ""
        },
        hospital: {
          hasError: false,
          isPristine: true,
          message: ""
        }
      },
      currentWeek: 0,
      formSent: false,
      open: false
    };
  }

  handleChange = event => {
    const targetName = event.target.name;
    const value = event.target.value;
    this.setState(prevState => ({
      formInputData: {
        ...prevState.formInputData,
        [targetName]: value
      }
    }));
    if (FIELD_VALIDATORS[targetName]) {
      if (!FIELD_VALIDATORS[targetName](value)) {
        this.setState(prevState => ({
          formInputData: {
            ...prevState.formInputData,
            [targetName]: value
          },
          errors: {
            ...prevState.errors,
            [targetName]: {
              hasError: true,
              message: FIELD_ERROR_MESSAGES[targetName].validation
            }
          }
        }));
      } else {
        this.setState(prevState => ({
          formInputData: {
            ...prevState.formInputData,
            [targetName]: value
          },
          errors: {
            ...prevState.errors,
            [targetName]: {
              hasError: false,
              message: ""
            }
          }
        }));
      }
    } else {
      this.setState(prevState => ({
        formInputData: {
          ...prevState.formInputData,
          [targetName]: value
        },
        errors: {
          ...prevState.errors,
          [targetName]: {
            hasError: false,
            message: ""
          }
        }
      }));
    }
  };

  handleFormFieldBlur = targetName => {
    if (
      this.state.formInputData[targetName] === "" &&
      targetName !== "hospital"
    ) {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          [targetName]: {
            isPristine: false,
            hasError: true,
            message: FIELD_ERROR_MESSAGES[targetName].required
          }
        }
      }));
    } else {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          [targetName]: {
            ...prevState.errors[targetName],
            isPristine: false
          }
        }
      }));
    }
  };

  async initialLoad() {
    const now = await getNow();

   // let hospital = {};
    if (now && now.spital) {
     // hospital = await getHospitalByDRG(now.spital.codDRGSpital);
      now.spital.sectii.numarPaturi = 22;
      if (
        now.spital.sectii.numarPaturiOcupate > now.spital.sectii.numarPaturi
      ) {
        now.spital.sectii.numarPacienti = now.spital.sectii.numarPaturiOcupate;
        now.spital.sectii.numarPaturiLibere = 0;
        now.spital.sectii.supraAlocare =
          now.spital.sectii.numarPaturiOcupate - now.spital.sectii.numarPaturi;
        now.spital.sectii.numarPaturiOcupate = now.spital.sectii.numarPaturi;
      } else {
        now.spital.sectii.numarPacienti = now.spital.sectii.numarPaturiOcupate;
        now.spital.sectii.numarPaturiLibere =
          now.spital.sectii.numarPaturi - now.spital.sectii.numarPaturiOcupate;
        now.spital.sectii.supraAlocare = 0;
      }
    }


    const claimsNo = await ClaimsService.getAllClaimsActiveCnt();
    

    this.setState({
      occupiedBeds:
        now && now.spital ? now.spital.sectii.numarPaturiOcupate : 0,
      freeBeds: now && now.spital ? now.spital.sectii.numarPaturiLibere : 0,
      allBeds: now && now.spital ? now.spital.sectii.numarPaturi : 0,
      noOfPatients: now && now.spital ? now.spital.sectii.numarPacienti : 0,
      overBeds: now && now.spital ? now.spital.sectii.supraAlocare : 0,
      yesterdayBeds:
        now && now.spital ? now.spital.sectii.numarPaturiOcupate : 0,
      nameSection:
        now && now.spital
          ? now.spital.sectii.codDRG + " " + now.spital.sectii.denumireHMS
          : "Nu s-au putut prelua datele de la server",
      nameHospital:
        now && now.spital
          ? "Spitalul Marie Curie"
          : "Nu s-au putut prelua datele de la server",
      dateLastUpdate:
        now && now.spital ? now.spital.sectii.dataGenerare : new Date(),
      inputs: now && now.spital ? now.spital.sectii.intrati : 0,
      outputs: now && now.spital ? now.spital.sectii.iesiti : 0,
      claimsNo: claimsNo,
      chartData: {
        labels: ["Ocupate", "Libere", "Suprapopulare"],
        datasets: [
          {
            data: [
              now && now.spital ? now.spital.sectii.numarPaturiOcupate : 0,
              now && now.spital ? now.spital.sectii.numarPaturiLibere : 0,
              now && now.spital ? now.spital.sectii.supraAlocare : 0
            ],
            backgroundColor: ["#029AB1", "#E0E0E0", "#ff0000"],
            hoverBackgroundColor: "#00d5dd"
          }
        ]
      },
      chartOptions: {
        cutoutPercentage: 60,
        circumference:
          now && now.spital
            ? Math.PI +
              (Math.PI / 27) * (now ? now.spital.sectii.supraAlocare : 0)
            : 0,
        rotation: -Math.PI,
        plugins: {
          datalabels: {
            backgroundColor: function(context) {
              return context.dataset.backgroundColor;
            },
            borderColor: "white",
            borderRadius: 25,
            borderWidth: 2,
            color: "white",
            display: function(context) {
              var dataset = context.dataset;
              var count = dataset.data.length;
              var value = dataset.data[context.dataIndex];
              return value > count * 1.5;
            },
            font: {
              weight: "bold",
              size: "16"
            },
            formatter: Math.round
          }
        }
      }
    });
    //console.log(this.state);
  }

  async componentDidMount() {
    this.setState({
      height: window.innerHeight - 100
    });
    await this.initialLoad();
  }



  // async setDataForCharts(weekNum) {
  //   const thisWeek = await getTimeFrame(
  //     moment()
  //       .startOf("week")
  //       .subtract(7 * weekNum, "day")
  //       .format("YYYY-MM-DD"),
  //     moment()
  //       .endOf("week")
  //       .subtract(7 * weekNum, "day")
  //       .add(1, "day")
  //       .format("YYYY-MM-DD")
  //   );
  //   let chartStatistics = { days: [], ins: [], outs: [] };
  //   let diagStatistics = { days: [], diags: [] };
  //   let avgOccupancy = { days: [], values: [] };
  //   let diagCodes = [];
  //   for (var day in thisWeek) {
  //     if (thisWeek[day].diagCodes) {
  //       diagCodes = thisWeek[day].diagCodes;
  //     }
  //   }
  //   for (var diag in diagCodes) {
  //     diagStatistics.diags.push({ name: diagCodes[diag], values: [] });
  //   }
  //   let cntDays = 0;
  //   let calculatedAverage = 0;
  //   for (var day in thisWeek) {
  //     avgOccupancy.days.push(thisWeek[day].day);
  //     avgOccupancy.values.push(thisWeek[day].avg);
  //     if (thisWeek[day].avg > 0.1) {
  //       cntDays += 1;
  //       calculatedAverage += thisWeek[day].avg;
  //     }
  //     chartStatistics.days.push(thisWeek[day].day);
  //     chartStatistics.ins.push(thisWeek[day].totalDiff.patientsIn);
  //     chartStatistics.outs.push(thisWeek[day].totalDiff.patientsOut);

  //     diagStatistics.days.push(thisWeek[day].day);
  //     if (thisWeek[day].diagCodes) {
  //       for (var diag in thisWeek[day].diff) {
  //         if (diagStatistics.diags[diag] && diagStatistics.diags[diag].values) {
  //           diagStatistics.diags[diag].values.push(
  //             thisWeek[day].diff[diag].patientsIn
  //           );
  //         }
  //       }
  //     } else {
  //       for (var diag in diagCodes) {
  //         diagStatistics.diags[diag].values.push(0.1);
  //       }
  //     }
  //   }

  //   if (cntDays > 0) {
  //     calculatedAverage = Math.round(calculatedAverage / cntDays, 1);
  //   }

  //   this.setState({
  //     chartStatistics: chartStatistics,
  //     diagStatistics: diagStatistics,
  //     avgOccupancy: avgOccupancy,
  //     calculatedAverage: calculatedAverage
  //   });
  // }

  sendClaim = () => {
    sendClaim({
      description: this.state.formInputData.diagnostic,
      maternity: this.state.formInputData.hospital,
      contact: {
        firstName: this.state.formInputData.firstName,
        lastName: this.state.formInputData.lastName,
        phone: this.state.formInputData.phoneNumber,
        email: this.state.formInputData.email
      },
      type: "public"
    });
    this.setState({ formSent: true });
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;
    const { errors } = this.state;
    if (!this.state.chartData) {
      return (
        <MuiThemeProvider theme={AppTheme}>
          <div
            className={classes.spinnerContainer}
            style={{ textAlign: "center" }}
          >
            <div className={classes.spinner}>
              <CircularProgress size={80} />
            </div>
            <h1>Vă rugăm așteptați să se încarce informațiile</h1>
          </div>
        </MuiThemeProvider>
      );
    } else {
      return (
        <MuiThemeProvider theme={AppTheme}>
          <Desktop>
            <div className={classes.requestFormDesktop}>
              <AppBar>
                <Toolbar>
                  <i className="medical-icon-i-intensive-care appToolbar-menu appToolbar-icon" />
                  <h3 className="appToolbar-title">
                    Spital MS Curie București - Secția Terapie Intensivă
                    Nou-Născuți
                  </h3>
                </Toolbar>
              </AppBar>

              <div className={classes.chartsDesktop}>
                <div className={classes.flexFormContainer}>
                  <Paper className={classes.formContainer}>
                    <h3 className={classes.formTitle}>Cerere de internare</h3>
                    {!this.state.formSent && (
                      <form
                        className={classes.form}
                        noValidate
                        autoComplete="off"
                      >
                        <div />
                        <div className={classes.nameRow}>
                          <FormControl error={errors.lastName.hasError}>
                            <InputLabel htmlFor="firstName">
                              Nume Pacient
                            </InputLabel>
                            <Input
                              inputProps={{
                                name: "lastName",
                                id: "lastName"
                              }}
                              required="false"
                              value={this.state.formInputData.lastName}
                              onChange={this.handleChange}
                              onBlur={() =>
                                this.handleFormFieldBlur("lastName")
                              }
                            />
                            <FormHelperText>
                              {errors.lastName.message}
                            </FormHelperText>
                          </FormControl>
                          <FormControl error={errors.firstName.hasError}>
                            <InputLabel htmlFor="firstName">
                              Prenume Pacient
                            </InputLabel>
                            <Input
                              inputProps={{
                                name: "firstName",
                                id: "firstName"
                              }}
                              value={this.state.formInputData.firstName}
                              onChange={this.handleChange}
                              onBlur={() =>
                                this.handleFormFieldBlur("firstName")
                              }
                            />
                            <FormHelperText>
                              {errors.firstName.message}
                            </FormHelperText>
                          </FormControl>
                        </div>
                        <FormControl
                          className={classes.formField}
                          error={errors.hospital.hasError}
                        >
                          <InputLabel htmlFor="hospital">Spital</InputLabel>
                          <Input
                            inputProps={{
                              name: "hospital",
                              id: "hospital"
                            }}
                            required={false}
                            value={this.state.formInputData.hospital}
                            onChange={this.handleChange}
                            onBlur={() => this.handleFormFieldBlur("hospital")}
                          />
                          <FormHelperText>
                            {errors.hospital.message}
                          </FormHelperText>
                        </FormControl>

                        <FormControl
                          className={classes.formField}
                          error={errors.diagnostic.hasError}
                        >
                          <InputLabel htmlFor="diagnostic">
                            Diagnostic/Simptomatologie
                          </InputLabel>
                          <Input
                            value={this.state.formInputData.diagnostic}
                            onChange={this.handleChange}
                            onBlur={() =>
                              this.handleFormFieldBlur("diagnostic")
                            }
                            inputProps={{
                              id: "diagnostic",
                              name: "diagnostic"
                            }}
                            multiline
                            rows="3"
                          />
                          <FormHelperText>
                            {errors.diagnostic.message}
                          </FormHelperText>
                        </FormControl>
                        <div className={classes.contact}>
                          <FormControl
                            className={classes.contactField}
                            error={errors.phoneNumber.hasError}
                          >
                            <InputLabel htmlFor="phoneNumber">
                              Telefon
                            </InputLabel>
                            <Input
                              value={this.state.formInputData.phoneNumber}
                              onChange={this.handleChange}
                              onBlur={() =>
                                this.handleFormFieldBlur("phoneNumber")
                              }
                              inputProps={{
                                id: "phoneNumber",
                                name: "phoneNumber"
                              }}
                            />
                            <FormHelperText>
                              {errors.phoneNumber.message}
                            </FormHelperText>
                          </FormControl>
                          <FormControl
                            className={classes.contactField}
                            error={errors.email.hasError}
                          >
                            <InputLabel htmlFor="email">Email</InputLabel>
                            <Input
                              value={this.state.formInputData.email}
                              onChange={this.handleChange}
                              onBlur={() => this.handleFormFieldBlur("email")}
                              inputProps={{
                                id: "email",
                                name: "email"
                              }}
                            />
                            <FormHelperText>
                              {errors.email.message}
                            </FormHelperText>
                          </FormControl>
                        </div>
                        <Button
                          className={classes.sendButton}
                          variant="contained"
                          color="primary"
                          onClick={this.sendClaim}
                          disabled={isSendButtonDisabled(this.state.errors)}
                        >
                          Trimite
                        </Button>
                      </form>
                    )}
                    <div>
                      {this.state.formSent && (
                        <Typography
                          variant="h4"
                          gutterBottom
                          style={{ padding: 20 }}
                        >
                          Vă mulțumim pentru înțelegere. <br /> <br /> Un cadru
                          medical vă va contacta pentru a face cât mai rapid
                          procedura de internare odata ce locurile în spital vor
                          fi disponibile. <br /> <br /> Mulțumim pentru
                          întelegere! <br /> Spital MS Curie București - Secția
                          Terapie Intensivă Nou-Născuți
                        </Typography>
                      )}

                      <Dialog
                        open={this.state.open}
                        onClose={this.handleClose}
                        aria-labelledby="responsive-dialog-title"
                      >
                        <DialogTitle id="responsive-dialog-title">
                          {"Inregistrare cerere de internare"}
                        </DialogTitle>
                        <DialogContent>
                          <DialogContentText>
                            Cererea dumneavoastră a fost înregistrată cu succes.
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={this.handleClose}
                            color="primary"
                            autoFocus
                          >
                            Inchide
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </div>
                  </Paper>
                </div>
                <Typography variant="subtitle1" gutterBottom>
                  <br /> <br /> Toate cererile vor fi preluate în ordinea
                  introducerii lor odată ce locurile în spital vor fi
                  disponibile. <strong>Urgențele au prioritate.</strong> <br />{" "}
                  <br /> Mulțumim pentru întelegere! <br /> Spital MS Curie
                  București - Secția Terapie Intensivă Nou-Născuți
                </Typography>
                <div
                  className={classes.center}
                  style={{
                    textAlign: "center",
                    fontSize: 10,
                    marginVertical: 20,
                    marginHorizontal:30,
                    paddingBottom:30,
                    fontWeight: "300"
                  }}
                >
                  &copy; {1900 + new Date().getYear()}, made with{" "}
                  <i
                    className="material-icons"
                    style={{ fontSize: 16, color: "#ff0000" }}
                  >
                    favorite
                  </i>{" "}
                  by{" "}
                  <a href="https://www.e-neonat.ro/echipa-cat" target="_blank">
                    Dr. Cătălin Cîrstoveanu
                  </a>
                  {" & "}
                  <a href="https://enso-foundation.org" target="_blank">
                    Bogdan Răduță
                  </a>
                  .
                </div>
              </div>
              <div className={classes.chartsDesktop}>
               

                <BedsAvailabilityCardBar
                  className={classes.bedsAvailabilityCardRootTablet}
                  claims={this.state.claimsNo}
                  onInternmentRequest={this.handleOnInternmentRequest}
                  occupiedBeds={this.state.occupiedBeds}
                  freeBeds={this.state.freeBeds}
                  overBeds={this.state.overBeds}
                  allBeds={this.state.allBeds}
                  inputs={this.state.inputs}
                  outputs={this.state.outputs}
                  noOfPatients={this.state.noOfPatients}
                  dateLastUpdate={this.state.dateLastUpdate}
                  buttonVisible={false}
                  height={this.state.height}
                />
              </div>
            </div>
          </Desktop>

          <Tablet>
            <div className={classes.requestFormTablet}>
              <AppBar>
                <Toolbar>
                  <i className="medical-icon-i-intensive-care appToolbar-menu appToolbar-icon" />
                  <h3 className="appToolbar-title">
                    Spital MS Curie București - Secția Terapie Intensivă
                    Nou-Născuți
                  </h3>
                </Toolbar>
              </AppBar>

              <Paper className={classes.formContainerTablet}>
                <h3 className={classes.formTitle}>Cerere de internare</h3>
                {!this.state.formSent && (
                  <form className={classes.form} noValidate autoComplete="off">
                    <div />
                    <div className={classes.nameRow}>
                      <FormControl error={errors.lastName.hasError}>
                        <InputLabel htmlFor="firstName">
                          Nume Pacient
                        </InputLabel>
                        <Input
                          inputProps={{
                            name: "lastName",
                            id: "lastName"
                          }}
                          value={this.state.formInputData.lastName}
                          onChange={this.handleChange}
                          onBlur={() => this.handleFormFieldBlur("lastName")}
                        />
                        <FormHelperText>
                          {errors.lastName.message}
                        </FormHelperText>
                      </FormControl>
                      <FormControl error={errors.firstName.hasError}>
                        <InputLabel htmlFor="firstName">
                          Prenume Pacient
                        </InputLabel>
                        <Input
                          inputProps={{
                            name: "firstName",
                            id: "firstName"
                          }}
                          value={this.state.formInputData.firstName}
                          onChange={this.handleChange}
                          onBlur={() => this.handleFormFieldBlur("firstName")}
                        />
                        <FormHelperText>
                          {errors.firstName.message}
                        </FormHelperText>
                      </FormControl>
                    </div>

                    <FormControl
                      className={classes.formField}
                      error={errors.hospital.hasError}
                    >
                      <InputLabel htmlFor="hospital">Spital</InputLabel>
                      <Input
                        inputProps={{
                          name: "hospital",
                          id: "hospital"
                        }}
                        required={false}
                        value={this.state.formInputData.hospital}
                        onChange={this.handleChange}
                        onBlur={() => this.handleFormFieldBlur("hospital")}
                      />
                      <FormHelperText>{errors.hospital.message}</FormHelperText>
                    </FormControl>

                    <FormControl
                      className={classes.formField}
                      error={errors.diagnostic.hasError}
                    >
                      <InputLabel htmlFor="diagnostic">
                        Diagnostic/Simptomatologie
                      </InputLabel>
                      <Input
                        value={this.state.formInputData.diagnostic}
                        onChange={this.handleChange}
                        onBlur={() => this.handleFormFieldBlur("diagnostic")}
                        inputProps={{
                          id: "diagnostic",
                          name: "diagnostic"
                        }}
                        multiline
                        rows="3"
                      />
                      <FormHelperText>
                        {errors.diagnostic.message}
                      </FormHelperText>
                    </FormControl>
                    <div className={classes.contact}>
                      <FormControl
                        className={classes.contactField}
                        error={errors.phoneNumber.hasError}
                      >
                        <InputLabel htmlFor="phoneNumber">Telefon</InputLabel>
                        <Input
                          value={this.state.formInputData.phoneNumber}
                          onChange={this.handleChange}
                          onBlur={() => this.handleFormFieldBlur("phoneNumber")}
                          inputProps={{
                            id: "phoneNumber",
                            name: "phoneNumber"
                          }}
                        />
                        <FormHelperText>
                          {errors.phoneNumber.message}
                        </FormHelperText>
                      </FormControl>
                      <FormControl
                        className={classes.contactField}
                        error={errors.email.hasError}
                      >
                        <InputLabel htmlFor="email">Email</InputLabel>
                        <Input
                          value={this.state.formInputData.email}
                          onChange={this.handleChange}
                          onBlur={() => this.handleFormFieldBlur("email")}
                          inputProps={{
                            id: "email",
                            name: "email"
                          }}
                        />
                        <FormHelperText>{errors.email.message}</FormHelperText>
                      </FormControl>
                    </div>
                    <Button
                      className={classes.sendButton}
                      variant="contained"
                      color="primary"
                      onClick={this.sendClaim}
                      disabled={isSendButtonDisabled(this.state.errors)}
                    >
                      Trimite
                    </Button>
                  </form>
                )}
                <div>
                  {this.state.formSent && (
                    <Typography
                      variant="h4"
                      gutterBottom
                      style={{ padding: 20 }}
                    >
                      Vă mulțumim pentru înțelegere. <br /> <br /> Un cadru
                      medical vă va contacta pentru a face cât mai rapid
                      procedura de internare odata ce locurile în spital vor fi
                      disponibile. <br /> <br /> Mulțumim pentru întelegere!{" "}
                      <br /> Spital MS Curie București - Secția Terapie
                      Intensivă Nou-Născuți
                    </Typography>
                  )}

                  <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                  >
                    <DialogTitle id="responsive-dialog-title">
                      {"Inregistrare cerere de internare"}
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        Cererea dumneavoastră a fost înregistrată cu succes.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={this.handleClose}
                        color="primary"
                        autoFocus
                      >
                        Inchide
                      </Button>
                    </DialogActions>
                  </Dialog>
                </div>
              </Paper>

              <div className={classes.bedsAvailabilityCardTablet}>
                <BedsAvailabilityCardBar
                  className={classes.bedsAvailabilityCardRootTablet}
                  claims={this.state.claimsNo}
                  onInternmentRequest={this.handleOnInternmentRequest}
                  occupiedBeds={this.state.occupiedBeds}
                  freeBeds={this.state.freeBeds}
                  overBeds={this.state.overBeds}
                  allBeds={this.state.allBeds}
                  inputs={this.state.inputs}
                  outputs={this.state.outputs}
                  noOfPatients={this.state.noOfPatients}
                  dateLastUpdate={this.state.dateLastUpdate}
                  buttonVisible={false}
                  height={this.state.height}
                />
              </div>

              <div className={classes.announceTablet}>
                <Typography variant="subtitle1" gutterBottom>
                  Toate cererile vor fi preluate în ordinea introducerii lor
                  odată ce locurile în spital vor fi disponibile.{" "}
                  <strong>Urgențele au prioritate.</strong> <br /> Mulțumim
                  pentru înțelegere !<br /> Spital MS Curie București - Secția
                  Terapie Intensivă Nou-Născuți
                </Typography>
                <div
                  className={classes.center}
                  style={{
                    textAlign: "center",
                    fontSize: 10,
                    marginVertical: 10,
                    marginHorizontal:30,
                    fontWeight: "300"
                  }}
                >
                  &copy; {1900 + new Date().getYear()}, made with{" "}
                  <i
                    className="material-icons"
                    style={{ fontSize: 14, color: "#ff0000" }}
                  >
                    favorite
                  </i>{" "}
                  by{" "}
                  <a href="https://www.e-neonat.ro/echipa-cat" target="_blank">
                    Dr. Cătălin Cîrstoveanu
                  </a>
                  {" & "}
                  <a href="https://enso-foundation.org" target="_blank">
                    Bogdan Răduță
                  </a>
                  .
                </div>
              </div>
            </div>
          </Tablet>

          <Mobile>
            <div className={classes.requestFormMobile}>
              <AppBar>
                <Toolbar>
                  <i className="medical-icon-i-intensive-care appToolbar-menu appToolbar-icon" />
                  <h3 className="appToolbar-title">
                    Spital MS Curie București - Secția Terapie Intensivă
                    Nou-Născuți
                  </h3>
                </Toolbar>
              </AppBar>

              <div className={classes.chartsMobile}>
                <div className={classes.flexContainer}>
                  <Paper className={classes.formContainerMobile}>
                    <h3>Disponibilitate paturi</h3>
                    <div className={classes.countersTablet}>
                      <div className={classes.allBedsCountTablet}>
                        <div style={{ flex: 1, flexDirection: "row" }}>
                          <Typography
                            variant="display3"
                            style={{ color: "#800080" }}
                          >
                            {this.state.claimsNo}
                          </Typography>
                          <Typography variant="subtitle1">
                            In asteptare
                          </Typography>
                        </div>
                      </div>
                      <div className={classes.allBedsCountTablet}>
                        <div>
                          <Typography variant="display3">
                            {this.state.allBeds}
                          </Typography>
                          <Typography variant="subtitle1">
                            Paturi Total
                          </Typography>
                        </div>
                        <div>
                          <Typography variant="display3">
                            {this.state.noOfPatients}
                          </Typography>
                          <Typography variant="subtitle1">
                            Numar Pacienti
                          </Typography>
                        </div>
                      </div>
                      <div className={classes.freeBedsCountTablet}>
                        <div>
                          <Typography
                            className={classes.freeBedsCountNumber}
                            variant="display3"
                          >
                            {this.state.freeBeds}
                          </Typography>
                          <Typography variant="subtitle1">
                            Paturi Libere
                          </Typography>
                        </div>
                        <div>
                          <Typography
                            className={classes.overBedsCountNumber}
                            variant="display3"
                          >
                            {this.state.overBeds}
                          </Typography>
                          <Typography variant="subtitle1">
                            Peste capacitate
                          </Typography>
                        </div>
                      </div>
                      <div className={classes.chartWrapper}>
                        <Pie
                          data={this.state.chartData}
                          options={this.state.chartOptions}
                        />
                      </div>
                    </div>
                  </Paper>
                </div>
                <div className={classes.flexFormContainer}>
                  <Paper className={classes.formContainerMobile}>
                    <h3>Cerere de internare</h3>
                    {!this.state.formSent && (
                      <form
                        className={classes.form}
                        noValidate
                        autoComplete="off"
                      >
                        <FormControl
                          className={classes.formField}
                          error={errors.lastName.hasError}
                        >
                          <InputLabel htmlFor="firstName">
                            Nume Pacient
                          </InputLabel>
                          <Input
                            inputProps={{
                              name: "lastName",
                              id: "lastName"
                            }}
                            value={this.state.formInputData.lastName}
                            onChange={this.handleChange}
                            onBlur={() => this.handleFormFieldBlur("lastName")}
                          />
                          <FormHelperText>
                            {errors.lastName.message}
                          </FormHelperText>
                        </FormControl>
                        <FormControl
                          className={classes.formField}
                          error={errors.firstName.hasError}
                        >
                          <InputLabel htmlFor="firstName">
                            Prenume Pacient
                          </InputLabel>
                          <Input
                            inputProps={{
                              name: "firstName",
                              id: "firstName"
                            }}
                            value={this.state.formInputData.firstName}
                            onChange={this.handleChange}
                            onBlur={() => this.handleFormFieldBlur("firstName")}
                          />
                          <FormHelperText>
                            {errors.firstName.message}
                          </FormHelperText>
                        </FormControl>
                        <FormControl
                          className={classes.formField}
                          error={errors.hospital.hasError}
                        >
                          <InputLabel htmlFor="hospital">Spital</InputLabel>
                          <Input
                            inputProps={{
                              name: "hospital",
                              id: "hospital"
                            }}
                            required={false}
                            value={this.state.formInputData.hospital}
                            onChange={this.handleChange}
                            onBlur={() => this.handleFormFieldBlur("hospital")}
                          />
                          <FormHelperText>
                            {errors.hospital.message}
                          </FormHelperText>
                        </FormControl>
                        <FormControl
                          className={classes.formField}
                          error={errors.diagnostic.hasError}
                        >
                          <InputLabel htmlFor="diagnostic">
                            Diagnostic/Simptomatologie
                          </InputLabel>
                          <Input
                            value={this.state.formInputData.diagnostic}
                            onChange={this.handleChange}
                            onBlur={() =>
                              this.handleFormFieldBlur("diagnostic")
                            }
                            inputProps={{
                              id: "diagnostic",
                              name: "diagnostic"
                            }}
                            multiline
                            rows="5"
                          />
                          <FormHelperText>
                            {errors.diagnostic.message}
                          </FormHelperText>
                        </FormControl>

                        <FormControl
                          className={classes.formField}
                          error={errors.phoneNumber.hasError}
                        >
                          <InputLabel htmlFor="phoneNumber">Telefon</InputLabel>
                          <Input
                            value={this.state.formInputData.phoneNumber}
                            onChange={this.handleChange}
                            onBlur={() =>
                              this.handleFormFieldBlur("phoneNumber")
                            }
                            inputProps={{
                              id: "phoneNumber",
                              name: "phoneNumber"
                            }}
                          />
                          <FormHelperText>
                            {errors.phoneNumber.message}
                          </FormHelperText>
                        </FormControl>
                        <FormControl
                          className={classes.formField}
                          error={errors.email.hasError}
                        >
                          <InputLabel htmlFor="email">Email</InputLabel>
                          <Input
                            value={this.state.formInputData.email}
                            onChange={this.handleChange}
                            onBlur={() => this.handleFormFieldBlur("email")}
                            inputProps={{
                              id: "email",
                              name: "email"
                            }}
                          />
                          <FormHelperText>
                            {errors.email.message}
                          </FormHelperText>
                        </FormControl>

                        <Button
                          className={classes.sendButton}
                          variant="contained"
                          color="primary"
                          onClick={this.sendClaim}
                          disabled={isSendButtonDisabled(this.state.errors)}
                        >
                          Trimite
                        </Button>
                      </form>
                    )}
                    <div>
                      {this.state.formSent && (
                        <Typography variant="h4" gutterBottom>
                          Vă mulțumim pentru înțelegere. <br /> <br /> Un cadru
                          medical vă va contacta pentru a face cât mai rapid
                          procedura de internare odata ce locurile în spital vor
                          fi disponibile.{" "}
                          <strong>Urgențele au prioritate.</strong> <br />{" "}
                          <br /> Mulțumim pentru întelegere! <br /> Spital MS
                          Curie București - Secția Terapie Intensivă Nou-Născuți
                        </Typography>
                      )}

                      <Dialog
                        open={this.state.open}
                        onClose={this.handleClose}
                        aria-labelledby="responsive-dialog-title"
                      >
                        <DialogTitle id="responsive-dialog-title">
                          {"Inregistrare cerere de internare"}
                        </DialogTitle>
                        <DialogContent>
                          <DialogContentText>
                            Cererea dumneavoastră a fost înregistrată cu succes.
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={this.handleClose}
                            color="primary"
                            autoFocus
                          >
                            Inchide
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </div>
                  </Paper>
                </div>
              </div>
              <div className={classes.announceTablet}>
                <Typography variant="subtitle1" gutterBottom>
                  Toate cererile vor fi preluate în ordinea introducerii lor
                  odată ce locurile în spital vor fi disponibile.{" "}
                  <strong>Urgențele au prioritate.</strong> <br /> Mulțumim
                  pentru întelegere! <br /> Spital MS Curie București - Secția
                  Terapie Intensivă Nou-Născuți
                </Typography>
              </div>
              <div
                className={classes.center}
                style={{
                  textAlign: "center",
                  fontSize: 10,
                  marginVertical: 10,
                  marginHorizontal:30,
                  paddingBottom:30,
                  fontWeight: "300"
                }}
              >
                &copy; {1900 + new Date().getYear()}, made with{" "}
                <i
                  className="material-icons"
                  style={{ fontSize: 16, color: "#ff0000" }}
                >
                  favorite
                </i>{" "}
                by{" "}
                <a href="https://www.e-neonat.ro/echipa-cat" target="_blank">
                  Dr. Cătălin Cîrstoveanu
                </a>
                {" & "}
                <a href="https://enso-foundation.org" target="_blank">
                  Bogdan Răduță
                </a>
                .
              </div>
            </div>
          </Mobile>
        </MuiThemeProvider>
      );
    }
  }
}

export default withStyles(styles)(RequestForm);
